import { render, staticRenderFns } from "./OpinionsList.vue?vue&type=template&id=7a8a0157&"
import script from "./OpinionsList.vue?vue&type=script&lang=js&"
export * from "./OpinionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports